import { useMemo, useState } from 'react'
import {
  GiftCardFormState,
  RecipientFormState,
  PaymentFormState,
} from '@mindfulchefuk/features/GiftCards/interfaces'

const initialState: GiftCardFormState = {
  amount: '60',
  recipientFirstName: '',
  recipientLastName: '',
  recipientEmail: '',
  recipientEmailConfirm: '',
  personalMessage: '',
  email: '',
  confirmEmail: '',
  firstName: '',
  lastName: '',
  sendGiftCardToRecipient: 'true',
}

type Hook = () => [
  {
    currentStep: number
    formState: GiftCardFormState
  },
  {
    setFormState: (fields: RecipientFormState | PaymentFormState) => void
    restartJourney: () => void
    setCurrentStep: (step: number | ((step: number) => number)) => void
  }
]

export const useGiftCardState: Hook = () => {
  const [currentStep, setCurrentStep] = useState<number>(0)
  const [formState, setFormState] = useState(initialState)

  const handlers: ReturnType<Hook>[1] = useMemo(
    () => ({
      setFormState: (newFields) =>
        setFormState((fields) => ({ ...fields, ...newFields })),
      setCurrentStep,
      restartJourney: () => {
        setCurrentStep(0)
        setFormState(initialState)
      },
    }),
    []
  )

  return [{ currentStep, formState }, handlers]
}
